import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Button from '@mui/material/Button';
import { IUser } from 'permisos-common';

interface IConfirmDeactiveUserDialogProps {
  onDeactiveUserConfirm: () => void;
  onDeactiveUserClose: () => void;
  isOpen: boolean;
  selectedUser: IUser | null;
}

export const ConfirmDeactiveUserDialog = (
  props: IConfirmDeactiveUserDialogProps
) => {
  const { onDeactiveUserConfirm, onDeactiveUserClose, isOpen, selectedUser } =
    props;

  return (
    <Dialog
      open={isOpen}
      onClose={onDeactiveUserClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          ¿Está seguro de desactivar usuario <b>{selectedUser?.username}</b> de
          la aplicación?
          <br />
          Nota:{' '}
          <span style={{ color: 'red' }}>
            <b>Esta acción no se podrá revertir</b>
          </span>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onDeactiveUserClose} autoFocus>
          Cancelar
        </Button>
        <Button variant="contained" onClick={onDeactiveUserConfirm}>
          Desactivar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
